import { sameSearch } from './recordViewerHistory';

const LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

// ENG-3550: the slideout viewer writes browser history without leaving the page (open,
// Back out of the viewer, Next within a page): same path, same query string. Reducers
// that reset page-scoped state on every LOCATION_CHANGE would wipe the record the viewer
// is loading and the table's selection, so those changes are marked here, against the
// router's previous location, before any reducer sees them.
export const samePageLocationMiddleware = (store) => (next) => (action) => {
  if (action?.type !== LOCATION_CHANGE) return next(action);
  const previous = store.getState().router?.location;
  const location = action.payload;
  const samePage = Boolean(previous && location)
    && previous.pathname === location.pathname
    && sameSearch(previous.search, location.search);
  return next(samePage ? { ...action, meta: { ...(action.meta || {}), samePage: true } } : action);
};

export const isSamePageLocationChange = (action) => Boolean(action?.meta?.samePage);
